export type BlogArticle = {
  slug: string;
  title: string;
  description: string;
  publishedAt: string;
  readingMinutes: number;
  badge: string;
  intro: string;
  sections: { title: string; body: string[] }[];
  relatedLinks: { to: string; label: string }[];
};

export const BLOG_ARTICLES: Record<string, BlogArticle> = {
  'photobooth-mariage-tunisie': {
    slug: 'photobooth-mariage-tunisie',
    title: 'Photobooth mariage en Tunisie : guide complet 2026',
    description:
      'Comment choisir un photobooth pour votre mariage en Tunisie : borne premium, tirages instantanés, animation et galerie en ligne. Conseils L Benna Production.',
    publishedAt: '2026-05-28',
    readingMinutes: 6,
    badge: 'Conseils · Photobooth',
    intro:
      'Le photobooth est devenu incontournable dans les mariages tunisiens : animation conviviale, souvenirs imprimés pour les invités et contenus fun pour les réseaux sociaux. Voici comment bien le choisir à Tunis, Djerba ou ailleurs en Tunisie.',
    sections: [
      {
        title: 'Pourquoi intégrer un photobooth à votre mariage ?',
        body: [
          'Entre la cérémonie et la soirée dansante, le photobooth crée un moment de détente où invités de tous âges participent. Les tirages instantanés deviennent des cadeaux personnalisés ; la galerie en ligne prolonge l\'expérience après la fête.',
          'Pour un mariage à Tunis ou en destination à Djerba, la borne s\'adapte au thème du wedding : fond personnalisé aux couleurs du couple, accessoires fun et animateur professionnel pour guider les invités.',
        ],
      },
      {
        title: 'Critères de choix : matériel, animateur et livrables',
        body: [
          'Privilégiez une borne premium avec éclairage studio et appareil reflex ou hybride — la qualité d\'image fait la différence sur les tirages et les partages Instagram.',
          'Vérifiez le nombre de tirages inclus, les formats (10×15, bandelettes), la présence d\'un animateur et la livraison d\'une galerie en ligne sécurisée sous 48 h.',
          'L Benna Production propose des formules clé en main à Tunis et Djerba, combinables avec reportage photo et film de mariage pour un package cohérent.',
        ],
      },
      {
        title: 'Budget et timing : quand réserver ?',
        body: [
          'Comptez entre 800 et 2 000 TND selon la durée, le nombre de tirages et les options (fond sur mesure, livre d\'or numérique). Réservez 3 à 6 mois à l\'avance en haute saison (printemps et automne).',
          'Installez la borne après le cocktail ou en début de soirée, dans un espace de 3×3 m minimum, avec accès électrique. Notre équipe gère l\'installation et le démontage sans stress pour les mariés.',
        ],
      },
    ],
    relatedLinks: [
      { to: '/photobooth', label: 'Location photobooth' },
      { to: '/photobooth-tunisie', label: 'Photobooth Tunisie' },
      { to: '/photobooth-djerba', label: 'Photobooth Djerba' },
      { to: '/portfolio/photobooth', label: 'Portfolio photobooth' },
      { to: '/mariage', label: 'Mariage photo & vidéo' },
    ],
  },
};

export function getBlogArticle(slug: string): BlogArticle | undefined {
  return BLOG_ARTICLES[slug];
}

export function listBlogArticles(): BlogArticle[] {
  return Object.values(BLOG_ARTICLES).sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
  );
}
